<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="リターゲティングタグ設定" />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <CampaignModalPageRetargetingList
        ref="tagList"
        :menuSetting="menuSetting"
      />
    </v-flex>
    <v-flex xs12 offset-xs1>
      <v-layout row>
        <v-flex xs3 md3 lg4 xl3 pl-4 pt-3>
          <h4 class="subheading grey--text text--darken-2">
            タグ送付先メールアドレス（任意）
          </h4>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-model="orderDescription.email"
            :error-messages="emailErrors"
            type="email"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="orderDescription.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import CampaignModalPageRetargetingList from './CampaignModalPageRetargetingList'
export default {
  name: 'CampaignModalRetargeting',
  components: {
    CampaignModalPageRetargetingList,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    errorMessage() {
      const errorMessages = []
      if (!this.$refs.tagList.validate()) {
        errorMessages.push(
          'リターゲティングタグの設定情報を正しく入力して下さい',
        )
      }
      if (this.emailErrors.length !== 0) {
        errorMessages.push(this.emailErrors[0])
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    orderDescription() {
      return this.menuSetting.orderDescription
    },
    emailErrors() {
      if (!this.isValidEmailsFormat()) {
        return ['メールアドレスを正しく入力してください']
      }
      return []
    },
  },
  methods: {
    isValidEmailsFormat() {
      if (!this.orderDescription.email) {
        return true
      }
      const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      if (regexp.test(this.orderDescription.email)) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
